import React from 'react';
import { AppBar, Toolbar, Box } from '@mui/material';

import Logo from '../Logo/Logo';
import InfoPopover from '../InfoPopover/InfoPopover';

const Header = () => {
  return (
    <AppBar
      position="static"
      color="primary"
      enableColorOnDark
      sx={{
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderBottom: '1px solid #ccc',
      }}
    >
      <Toolbar sx={{ justifyContent: 'center', padding: '10px 0' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <InfoPopover />
          <Logo />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
